import React from 'react';
import { motion } from 'framer-motion';
import { cars } from '../data/mockData';
import CarCard from '../components/CarCard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Showroom() {
  return (
    <div className="min-h-screen pt-28 pb-20 px-6 max-w-7xl mx-auto">
      <div className="mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-zinc-800/50 pb-8">
        <div>
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-2 text-amber-400 mb-2"
          >
            <SafeIcon icon={FiIcons.FiGrid} />
            <span className="text-xs font-bold tracking-widest uppercase">/// Data Utility Configurator</span>
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-zinc-100"
          >
            Select Node Architecture
          </motion.h1>
          <p className="text-xs text-zinc-500 mt-2 tracking-wide">
            Three archetypes. Infinite configurations. Choose your sovereign chassis.
          </p>
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-zinc-500 text-xs font-mono bg-zinc-900/50 px-4 py-2 rounded border border-zinc-800"
        >
          NODE_MODELS_AVAILABLE: <span className="text-cyan-400">{cars.length}</span>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {cars.map((car, index) => (
          <CarCard key={car.id} car={car} index={index} />
        ))}
      </div>
    </div>
  );
}